import { render } from "./TableHeaderComponent.vue?vue&type=template&id=36ea50f4&ts=true"
import script from "./TableHeaderComponent.ts?vue&type=script&lang=ts"
export * from "./TableHeaderComponent.ts?vue&type=script&lang=ts"

import "./TableHeaderComponent.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__